import { render, staticRenderFns } from "./Sectionfooter.vue?vue&type=template&id=48a36109&"
import script from "./Sectionfooter.vue?vue&type=script&lang=js&"
export * from "./Sectionfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports